import { Link } from 'react-router'

export function ApoyarPage() {
  return (
    <div className="legal-page">
      <div className="legal-inner">
        <h1 className="legal-title">Apoya este proyecto</h1>
        <p className="apoyar-desc">Hemiciclo es un proyecto independiente y sin fines de lucro. Si te parece útil, considera hacer una donación para ayudar a mantenerlo funcionando.</p>
        <iframe
          id="kofiframe"
          src="https://ko-fi.com/aotarola/?hidefeed=true&widget=true&embed=true&preview=true"
          className="kofi-iframe"
          height="712"
          title="Apoya Hemiciclo en Ko-fi"
        ></iframe>
        <Link to="/" className="legal-back">← Volver al inicio</Link>
      </div>
    </div>
  )
}
